import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const fitness: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.FITNESS,
  label: "Fitness",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "current fitness routine and how consistently it's kept up",
    "any training specific to the target role's physical abilities test, and how recently",
    "whether a practice run or official test has been attempted, and the result",
  ],
  followUpTriggers: [
    "the routine is described only in adjectives (\"pretty active\") with no specifics",
    "\"recently\" is used without a timeframe for test-specific training",
    "a practice run/test is mentioned with no result or time given",
  ],
  hardBarrierFacts: [],
};
